import { USERS_ENDPOINT } from "Constants";
import { UserUpdatesMessage, WhoamiResponse } from "Types";
import { baseApi } from "./base.api";
import { listenToUserUpdates } from "./websocket";
import { updateWhoamiCache } from "./whoamiWebsocketUpdates";

export const whoamiApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getWhoami: build.query<WhoamiResponse, void>({
      query: () => ({ url: `${USERS_ENDPOINT}/users/whoami` }),
      async onCacheEntryAdded(
        arg,
        { updateCachedData, cacheDataLoaded, cacheEntryRemoved },
      ) {
        const listener = (event: MessageEvent) => {
          const data = JSON.parse(event.data) as UserUpdatesMessage;

          if (data.entity === "current_user") {
            updateCachedData((draft) => {
              return updateWhoamiCache(draft, data);
            });
          }
        };

        await listenToUserUpdates(cacheDataLoaded, cacheEntryRemoved, listener);
      },
      providesTags: ["Users", "Groups", "Organizations", "Whoami"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetWhoamiQuery } = whoamiApi;
